<template>	
		<div class="featured-insights-block section-is-dark">
			<div class="featured-insights-block-container background-is-navy background-is-dark"
				 :style="{ 'background-color': '#808080',  'background-image': 'linear-gradient(rgba(0, 101, 160, 0.9), rgba(0, 101, 160, 0.9)), url(' + encodeURI(content.BackgroundImage) + ')' }"
			>
				<div class="row no-gutters">
					<div class="col-12 col-lg-7 align-self-end align-self-md-center">
						<div class="featured-insights-block-left mb-2 mb-md-0">
							<div class="d-flex flex-column h-100 justify-content-center align-items-center">
								<div class="w-100">
									<h3 class="heading-callout featured-insights-block-heading">
										{{content.Headline}}
									</h3>
									<p>
										{{content.TileCopy}}
									</p>
									<h-button :url="content.Url">View content</h-button>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-5">
						<div class="d-flex flex-column justify-content-end align-items-end h-100">
							<div class="d-flex right-callout background-is-navy-transp background-is-left-notched w-100">
								<div class="featured-insights-block-area pr-4">
									<div class="heading-4 pb-4" v-if="content.EyebrowHeading != ''">{{content.EyebrowHeading}}</div>
									<div class="pb-5" v-for="article in content.visibleArticles" :key="article.Headline" v-if="article.isShown">
										<div class="heading-5 featured-insights-block-date">{{article.FormattedPublishedDate}}</div>
										<div class="heading-4 featured-insights-block-link"> 
											<a :href="article.Url">
												<span class="featured-insights-block-link-inner">{{article.Headline}}</span>
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
</template>

<script>

	import Link from "../components/Link";
	import HButton from '../components/HButton.vue';


export default {

	components: {
		Link,
		HButton,
	},
	props: {

		content: {
			type: Object,
			default: function () { 
				return {
					"EyebrowHeading": "",
					"Headline": "Private Markets in Asia",
					"BackgroundImage": "~/getmedia/a265f239-7ae6-4f9f-a7bd-00f242bd8cc0/homepage_productinterior-header?width=1440&height=296&ext=.png",
					"ColorOverlay": "",
					"IntroCopy": "Asia's private market landscape is very large and diverse, with enormous regional variations. Join us as we take a whirlwind of a country-by-country tour of the Asian private markets.",
					"Url": "/",
					"ChapteredArticles": [
					],
					"visibleArticles": [
					]
				}
			}
		},
	}

}
</script>

<style lang="scss">
body.ie {
	.featured-insights-block {
		margin-bottom: 1rem;
	}
}
.featured-insights-block {
	&-left {
		padding: $bigPaddingSize;

		@include respond-below(lg) {
			padding: $bigPaddingSize/2;
		}
	}
	.featured-insights-block-area
	{
		padding-top: 35px;
	}

	.featured-insights-block-heading {
		line-height: 1.5;
		font-size: rem(48);

		@include respond-below(lg) {
			font-size: rem(40);
		}
	}

	.featured-insights-block-date {
		color: #a3b1bf;
	}
	.featured-insights-block-link {
		display: block;
		text-decoration: none;
		.featured-insights-block-link-inner {
			position: relative;

			&:before {
				content: '';
				display: block;
				position: absolute;
				width: 100%;
				bottom: -10px;
				height: 1px;
				background-color: $orangeText;
				transition: width 0.5s ease;
			}
		}

		a {
			font-family: $fontFamilyName;
		}

		&:hover {
			a {
				color: $orangeText;
				text-decoration: none !important;
			}

			.featured-insights-block-link-inner:before {
				width: calc(100% + 2em);
			}
		}
	}

	@include respond-below(lg) {
		// height: 500px;
	}

	.featured-insights-block-container{
		background-size: cover;
		background-repeat: no-repeat;
		background-position: 50% 50%;
		height:100%;
	}

	@include respond-above(lg) {
		// height: 550px;
	}

	.right-callout {
		height: 100%;
		z-index: 1;


		@include respond-above(lg) {
			margin-top: 1.5em;
		}
	}

	.featured-insights-block-container-mobile{
		background: $blueText;
		margin-top: -15%;
	}

	.right-callout-mobile{
		z-index: 1;

	}


}

</style>
